import styled, { keyframes } from "styled-components";

import HerologoMark from "@assets/images/lndn-2020/logoMark.svg";
import ImgHeroBottom from "@assets/images/lndn-2020/hero-bottom-bg-image.webp";
import ImgLinenBootomBg from "@assets/images/lndn-2020/linen-bottom-separator.jpg";
import { ReactSelectContainer } from "@layouts/homeLayout/ui/select";
import { Primarybutton } from "@layouts/homeLayout/ui/buttons";

import ImgPaediatricianBgMobile from "@assets/images/lndn-2020/paediatrician-bg-mobile.jpg";
import ImgPaediatricianBg from "@assets/images/lndn-2020/paediatrician-bg.jpg";

import IconStarOn from "@assets/images/lndn-2020/icon-star-on.svg";
import IconStarOff from "@assets/images/lndn-2020/icon-star-off.svg";
import IconQuoteGrey from "@assets/images/lndn-2020/icon-quote-grey.svg";
import IconAngleLeft from "@assets/images/lndn-2020/icon-angle-left.svg";
import IconGoogleRating from "@assets/images/lndn-2020/icon-google-rating.webp";
import IconAngleRight from "@assets/images/lndn-2020/icon-angle-right.svg";
import IconFaqMinus from "@assets/images/lndn-2020/icon-faq-minus.svg";
import IconFaqPlus from "@assets/images/lndn-2020/icon-faq-plus.svg";

export const HomePageWrap = styled.div`
  position: relative;
  overflow-x: hidden;
`;

export const HomePageHero = styled.div`
  padding-top: 130px;
  background: url(${HerologoMark}),
    linear-gradient(
      140.33deg,
      rgba(199, 231, 242, 0.312254) 39.5%,
      #abddea 104.82%
    );
  background-position: right top, center center;
  background-repeat: no-repeat;

  @media (max-width: 991px) {
    background-position: calc(100% + 300px) top, center center;
    padding-top: 20px;
  }
`;

export const HeroBottom = styled.div`
  padding: 50px 0 0;
  background-image: url(${ImgHeroBottom});
  background-position: left top;
  background-repeat: no-repeat;
  background-size: 100% 50px;
`;

export const HeroTop = styled.div`
  .row {
    align-items: center;
  }

  h1 {
    font-size: 22px;
    color: #10a6bd;
    margin-bottom: 2px;

    @media (max-width: 991px) {
      font-size: 18px;
    }
  }

  h2 {
    font-size: 52px;
    font-weight: 300;
    margin-bottom: 50px;
    position: relative;

    @media (max-width: 991px) {
      font-size: 46px;
    }
  }

  @media (max-width: 991px) {
    text-align: center;
  }
`;

export const HeroArrowdownImg = styled.img`
  position: absolute;
  top: 100%;
  left: 20px;
  width: 45px;
  margin-top: 20px;
`;

export const HeroTopContent = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 60px 0 10px;
`;

export const HeroActions = styled.div`
  text-align: center;
  width: 100%;

  button {
    width: 100%;
    max-width: 220px;
    margin: 0 auto 10px;
  }

  span {
    font-size: 18px;
    display: block;
    margin-bottom: 25px;
  }
`;

export const HeroSpecialties = styled.div`
  padding: 0px;
  margin: 0px;
  margin: auto;
  width: 240px;
  .row {
    margin: 0px !important;
  }
`;

export const IpadImgRow = styled.div`
  padding: 0 !important;
`;

export const IpadImgWrap = styled.picture`
  display: flex;
  justify-content: flex-end;
`;

export const IpadImg = styled.img`
  width: 100%;
  height: auto;
  margin-left: auto;

  @media (max-width: 991px) {
    width: 90%;
    height: auto;
    margin-left: auto;
    margin-top: 35px;
    margin-bottom: -200px;
  }
`;

export const HeroCounter = styled.div`
  background-color: #fbf4ec;
  padding: 30px 0;

  @media (max-width: 991px) {
    padding-top: 200px;
  }
`;

export const CounterLarge = styled.span`
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  font-size: 56px;
  margin-bottom: 15px;

  @media (max-width: 991px) {
    font-size: 42px;
  }
`;

export const CounterImg = styled.img`
  width: 55px;
  height: 55px;
  margin-right: 10px;

  @media (max-width: 991px) {
    width: 40px;
    height: 40px;
  }
`;

export const CounterSmall = styled.span`
  display: block;
  text-align: center;
  font-size: 20px;
  color: #416088;

  @media (max-width: 991px) {
    margin-bottom: 25px;
    font-size: 16px;
  }
`;

export const SectionWrap = styled.div`
  padding: 85px 0;

  @media (max-width: 991px) {
    padding: 40px 0;
  }

  &.centered {
    text-align: center;
  }

  &.white {
    background: #fff;

    h2 span {
      color: #e9bd8b;

      &.teal {
        color: #10a6bd;
      }
    }
  }

  &.sand {
    background: #f6f1f0;
  }

  &.linen {
    background: #fbf4ec;

    h2 span {
      color: #e9bd8b;

      &.teal {
        color: #10a6bd;
      }
    }

    &.with-bg-bottom {
      background-image: url(${ImgLinenBootomBg});
      background-size: 100% 30px;
      background-position: center bottom;
      background-repeat: no-repeat;
    }

    &.white-mobile {
      @media (max-width: 991px) {
        background: #fff;
      }
    }
  }

  &.sec-paediatrician {
    position: relative;
    background-image: url(${ImgPaediatricianBgMobile});
    background-size: cover;
    background-position: center center;
    color: #fff;
    padding-bottom: 0;
    overflow: hidden;

    .col-12 {
      z-index: 1;
    }

    ${Primarybutton} {
      z-index: 2;
      position: relative;
    }

    p {
      z-index: 2;
      position: relative;
    }

    @media (min-width: 991px) {
      background-image: url(${ImgPaediatricianBg});
    }

    @media (max-width: 991px) {
      p {
        padding-right: 35%;
      }
    }

    @media (max-width: 481px) {
      padding-right: 10%;
    }

    h2 {
      margin-bottom: 50px;
    }

    h2 span {
      color: #fbe8d3;
    }

    button {
      margin-top: 50px;
      margin-bottom: 50px;
    }
  }

  &.teal {
    background: #10a6bd;
    color: #171738;
    a {
      color: white;
    }
    h2 {
      color: #fff;

      span {
        color: #171738;
      }
    }
  }
`;

export const ImgChatJohn = styled.img`
  position: absolute;
  width: auto !important;
  height: auto;
  max-width: 50% !important;
  height: auto;
  bottom: 0;
  right: -12%;

  @media (max-width: 481px) {
    max-width: 85% !important;
    z-index: 0;
    right: -32%;
  }
`;

export const SectionHeader = styled.h2`
  font-size: 56px;
  font-weight: 400;
  line-height: 1.2;
  margin: 0 auto 30px;
  max-width: 820px;

  @media (max-width: 991px) {
    font-size: 42px;
  }

  span {
    display: block;
    text-transform: uppecase;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
  }
`;

export const SectionParagraph = styled.p`
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 481px) {
    font-size: 15px;
  }
`;

export const SectionVideo = styled.div`
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

export const VideoWrap = styled.div`
  margin-left: calc(var(--bs-gutter-x) * -0.5);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  video,
  img {
    width: 95%;
    height: auto;
    margin-bottom: 20px;
  }
`;

export const SectionLogosWrap = styled.div`
  background: #2b4d7a;
  padding: 30px 0;
  color: #fff;

  .col {
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 991px) {
      flex-direction: column;
    }
  }

  span {
    margin: 0 35px;
    font-size: 52px;

    @media (max-width: 991px) {
      margin-bottom: 25px;
    }
  }

  p {
    max-width: 400px;
    font-size: 18px;
    line-height: 1.4;

    @media (max-width: 991px) {
      max-width: 520px;
      margin-top: 30px;
    }
  }
`;

export const SectionLogosInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 991px) {
    flex-direction: column-reverse;

    img {
      max-width: 90%;
    }
  }
`;

export const AdvanceQueenslandImage = styled.img``;

export const SpecialistsListWrap = styled.div`
  margin: 40px auto 0 !important;
  max-width: 920px;

  ul {
    padding: 0 30px;
    margin: 0;
    list-syle: none;
    text-align: left;
    @media (max-width: 991px) {
      padding: 0 5px;
    }

    li {
      padding: 5px 0;
      @media (max-width: 991px) {
        font-size: 14px;
      }
    }
  }
`;

export const RequestBlock = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 20px 30px 0px rgba(28, 40, 44, 0.2);
  border-radius: 8px;
  min-height: 100%;

  h3 {
    padding: 40px 20px 20px;
    background: #2b4d7a;
    color: #fff;
    font-size: 30px;
    text-align: left;
    line-height: 1.2;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  p {
    padding: 30px 20px;
    background: #ffffff;
    text-align: left;
    font-size: 18px;
    line-height: 1.7;
  }

  a {
    display: block;
    padding: 20px;
    margin-top: auto;
    background: #10a6bd;
    color: #fff;
    font-size: 20px;
    text-transform: uppercase;
    font-weight: 600;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    &:hover {
      text-decoration: none;
      background: #0e9bb1;
    }
  }

  @media (max-width: 991px) {
    min-height: 0;
    margin-bottom: 40px;

    h3 br {
      display: none;
    }

    a {
      maring-top: 0;
    }
  }
`;

export const ReactSelectContainerExpand = styled(ReactSelectContainer)`
  margin-top: ${(props) => (props.noMargin ? "0px" : "50px")};

  @media (max-width: 991px) {
    margin-top: ${(props) => (props.noMargin ? "0px" : "30px")};
  }
`;

export const DrListWrap = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

export const DrListItem = styled.div`
  width: 50px;
  margin: 15px;
  img {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    margin-bottom: 5px;
  }
`;

export const DrListItemImg = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 25px;
  margin-bottom: 5px;
`;

export const DrListItemName = styled.span`
  display: block;
  font-size: 10px;
  color: #999;
`;

export const NewsRoomItem = styled.div`
  background: #fff;
  border-radius: 8px;
  margin: 20px;
`;

export const NewsRoomItemImg = styled.img`
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const NewsRoomItemText = styled.div`
  padding: 30px 35px;
  text-align: left;

  h4 {
    color: #10a6bd;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 25px;
  }

  p {
    font-size: 18px;
    line-height: 1.4;
    color: #6f6f6f;
  }
`;

export const NewsRoomItemActions = styled.div`
  padding: 0 35px 35px;
  display: flex;
  align-items: center;

  button,
  a {
    padding: 12px;
    font-size: 15px;
    text-transform: uppercase;
    width: 50%;
  }
`;

export const SectionActions = styled.div`
  text-align: center;
  max-width: 820px;
  margin: 50px auto 0;

  button {
    width: 100%;
    max-width: 220px;
    margin: 0 auto 10px;
  }

  span {
    font-size: 18px;
    display: block;
    margin-bottom: 25px;
  }
`;

export const ReviewWrap = styled.div`
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
`;

export const ReviewWrapItem = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100%;
`;

export const ReviewWrapInner = styled.div`
  position: relative;
  padding: 20px 40px 40px;
  background-color: #fafafa;
  flex: 1;
  box-shadow: 0 0 1px rgba(0, 0, 0, 10%);
  border-radius: 4px;
  background-image: url(${IconQuoteGrey});
  background-position: 12px 15px;
  background-repeat: no-repeat;
  background-size: 20px 26px;
`;

export const ReviewWrapItemText = styled.div`
  text-align: left;
  line-height: 1.5;
  color: #7b7b7b;
  font-size: 14px;
  height: 100%;
`;

export const ReviewWrapItemStart = styled.span`
  display: inline;
  margin-right: 5px;
`;

export const IconStar = styled.i`
  display: inline-block;
  margin: 0 2px;
  width: 14px;
  height: 14px;

  &.on {
    background-image: url(${IconStarOn});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &.off {
    background-image: url(${IconStarOff});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
  }
`;

export const IconGoogleSmall = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  background-image: url(${IconGoogleRating});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const ReviewWrapItemAuthor = styled.div`
  position: relative;
  padding: 25px 20px 0 80px;
  text-align: left;
  height: 60px;
  margin-bottom: 40px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    position: absolute;
    top: 20px;
    left: 20px;
  }

  span {
    display: block;
    color: #397cf0;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 3px;
  }

  small {
    display: block;
    color: #7b7b7b;
    font-size: 14px;
  }
`;

export const ReviewWrapDots = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 60px;
`;

export const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: rgba(0, 0, 0, 15%);
  flex: 0 0 10px;
  margin: 5px;
  cursor: pointer;

  &.active,
  &:hover {
    background: #397cf0;
  }
`;

export const ReviewWrapNav = styled.div`
  a {
    width: 32px;
    height: 32px;
    border-radius: 20px;
    position: absolute;
    top: 85px;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 5%);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 6px;

    &:hover {
      background-color: rgba(0, 0, 0, 8%);
    }
  }
`;

export const NavLeft = styled.a`
  left: -40px;
  background-image: url(${IconAngleLeft});
`;

export const NavRight = styled.a`
  right: -40px;
  background-image: url(${IconAngleRight});
`;

export const GoogleRateBadge = styled.img`
  display: block;
  width: 220px;
  height: 70px;
  margin: 60px auto 0;
`;

///Animations
const fadeIn = keyframes`
0% {
  opacity: 0;
  transform: translateY(-20px);
}
100% {
  opacity: 1;
  transform: translateY(0);
}`;

const fadeOut = keyframes`
0% {
  opacity: 1;
  transform: translateY(-20px);
}
100% {
  opacity: 0;
  transform: translateY(0);
}`;

export const SideLinks = styled.div`
  z-index: 1;
  position: fixed;
  top: 35vh;
  right: 0;
  height: 100%;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &.show {
    display: block;
    animation-name: ${fadeIn};
    animation-duration: 3s;
    animation-iteration-count: 1;
  }
  &.hide {
    display: none;
    animation-name: ${fadeOut};
    animation-duration: 3s;
    animation-iteration-count: 1;
  }
`;

export const SideLinksInner = styled.div`
  pointer-events: all;
  width: 80px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0px 8px 12px rgba(28, 40, 44, 0.105605);
  border-radius: 16px 0px 0px 16px;
  padding: 20px 0 1px;
`;

export const SideLinksIcon = styled.a`
  display: block;
  text-align: center;
  margin-bottom: 25px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 10px;
  }

  &:hover {
    text-decoration: none;
    opacity: 0.8;
  }

  img {
    display: block;
    width: 42px;
    height: 42px;
    margin: 0 auto 10px;
  }

  span {
    display: block;
    font-size: 14px;
    color: #000;
    line-height: 1.2;
  }
`;

export const FaqWrap = styled.div`
  text-align: left;
`;

export const FaqWrapItem = styled.div`
  background: #ffffff;
  border: 1px solid #e5eaf4;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  color: #183b56;
  padding: 35px 40px;
  margin-bottom: 15px;
  cursor: pointer;

  span,
  p {
    display: block;
    font-size: 20px;
    line-height: 1.25;
    text-align: left;
  }

  span {
    position: relative;
    padding-right: 30px;
    text-align: justify;

    &:after {
      content: "";
      position: absolute;
      top: 6px;
      right: 0;
      width: 15px;
      height: 15px;
      background-image: url(${IconFaqPlus});
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  .answerWrap {
    display: none;

    p {
      display: inline-block;
      text-align: left;
    }
  }

  &.active {
    span {
      color: #10a6bd;
      font-weight: 600;
      margin-bottom: 15px;

      &:after {
        background-image: url(${IconFaqMinus});
      }
    }

    .answerWrap {
      display: block;
    }
  }
`;
